import { render, staticRenderFns } from "./DepartmentSelect.vue?vue&type=template&id=359c7df2&scoped=true"
import script from "./DepartmentSelect.vue?vue&type=script&lang=js"
export * from "./DepartmentSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359c7df2",
  null
  
)

export default component.exports